module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"regionOverview.title":"Region Overview","regionOverview.filterNumber":"Minimum Spend","regionOverview.error.loadingRegions":"There was an issue loading your regions. If this problem persists please contact support.","regionOverview.error.loadingRegionTotals":"There was an issue loading your region spend. If this problem persists please contact support."}}')
  delete Component.options._Ctor
}
